<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps<{ params?: { data?: any } }>()

const partnerId = computed(() => {
  const d = props.params?.data
  return d?.parentId?.id ?? d?.company?.referenceExterne
})

const companyName = computed(() => {
  const d = props.params?.data
  return d?.parentId?.name ?? d?.company?.name ?? '-'
})
</script>

<template>
  <RouterLink
    v-if="partnerId"
    :to="`/partner/${partnerId}`"
    class="link link-primary hover:underline"
  >
    {{ companyName }}
  </RouterLink>
  <span v-else>{{ companyName }}</span>
</template>
